import React from "react";
import styles from "./nextButton.scss";
import { Button } from "../../../../components/Button/Button";

export interface NextButtonProps {
  onClick: (event) => void;
  isLoading: boolean;
  isUpdate: boolean;
}

const NextButton = (props: NextButtonProps): JSX.Element => {
  const { onClick, isLoading, isUpdate } = props;
  return (
    <Button
      type="primary"
      className={styles.button}
      onClick={onClick}
      disabled={isLoading}
      loading={isLoading}
    >
      {isUpdate ? "Ažuriraj oglas" : "Objavi oglas"}
    </Button>
  );
};

export default NextButton;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/StepFooter/NextButton/index.tsx